import React from "react";
import { useTranslation } from "react-i18next";

// WS / MSRP quick-pick chips for price inputs. Tapping a chip fills the
// price field with that value; the field itself stays fully editable so a
// custom price can always be typed regardless of the selection.
export function PriceChips({ wholesale, retail, value, onPick, testIdPrefix = "price-chip" }) {
  const { t } = useTranslation();
  const chips = [
    { key: "ws", label: t("pricing.wholesale_short"), price: wholesale },
    { key: "msrp", label: t("pricing.retail_short"), price: retail },
  ].filter((c) => c.price != null && c.price !== "" && Number.isFinite(Number(c.price)));
  if (chips.length === 0) return null;
  const isActive = (p) => value !== "" && value != null && Number(value) === Number(p);
  return (
    <div className="flex flex-wrap items-center gap-1.5 mt-1.5">
      {chips.map((c) => (
        <button
          key={c.key}
          type="button"
          onClick={() => onPick(Number(c.price).toFixed(2))}
          data-testid={`${testIdPrefix}-${c.key}`}
          className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full border text-[11px] font-semibold transition-colors ${
            isActive(c.price)
              ? "bg-zinc-900 text-white border-zinc-900"
              : "bg-white text-zinc-700 border-zinc-300 hover:border-zinc-900 hover:bg-zinc-50"
          }`}
        >
          {c.label} · ${Number(c.price).toFixed(2)}
        </button>
      ))}
    </div>
  );
}
